import $ from "jquery";
import { startResendTimer } from '../utils/utils-timer.js';
import { bindOtpInputs } from '../utils/utils-otp.js';
import { setButtonLoading, resetButtonLoading } from '../utils/utils-loading.js';

const resetPassword = () => {
    const el = {
        resetPage: '#reset-password-page',
        stepEmail: '#step-login',
        stepOtp: '#step-otp',
        stepChangePassword: '#step-change-password',
        stepSuccess: '#step-reset-success',
        formResetPassword: '#form-reset-password',
        formOtp: '#form-otp',
        formChangePassword: '#form-change-password',
        btnBackReset: '#btn-back-reset',
        btnBackChange: '#btn-back-change',
        btnResend: '#btn-resend',
        resendTimer: '#resend-timer',
        email: '#email',
        newPassword: '#new-password',
        confirmPassword: '#confirm-password',
        errEmail: '#error-email',
        errOtp: '#error-otp',
        errNewPassword: '#error-new-password',
        errConfirmPassword: '#error-confirm-password',
        otpDigits: '.mi-login__otp-digit',
        loginStep: '.mi-login__step',
        otpEmail: '#otp-email',
    };

    // let _user_id = null;
    let _reset_token = null;

    if (!$(el.resetPage).length) return;

    const init = () => {
        bindEmail();
        bindOtp();
        bindChangePassword();
        bindBack();
        bindOtpInputs(el.otpDigits, 5);
        bindResend();
    };

    const showStep = (stepSelector) => {
        $(el.loginStep).removeClass('mi-login__step--active');
        $(stepSelector).addClass('mi-login__step--active');
    };

    // Validations 
    const validateEmail = () => {
        let valid = true;
        $(el.email).removeClass('is-error');
        $(el.errEmail).text('').removeClass('is-visible');

        const val = $(el.email).val().trim();
        if (!val) {
            $(el.errEmail).text('Bitte E-Mail eingeben.').addClass('is-visible');
            $(el.email).addClass('is-error');
            valid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
            $(el.errEmail).text('Bitte gültige E-Mail eingeben.').addClass('is-visible');
            $(el.email).addClass('is-error');
            valid = false;
        }
        return valid;
    };

    const validateOtp = () => {
        $(el.errOtp).text('').removeClass('is-visible');
        const otp = $(el.otpDigits).map(function () { return $(this).val(); }).get().join('');
        if (otp.length < 5) {
            $(el.errOtp).text('Bitte vollständigen Code eingeben.').addClass('is-visible');
            return false;
        }
        return true;
    };

    const validateChangePassword = () => {
        let valid = true;
        const newPass = $(el.newPassword).val();
        const confirmPass = $(el.confirmPassword).val();
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,}$/;

        $(el.newPassword).removeClass('is-error');
        $(el.confirmPassword).removeClass('is-error');
        $(el.errNewPassword).text('').removeClass('is-visible');
        $(el.errConfirmPassword).text('').removeClass('is-visible');

        if (!newPass) {
            $(el.errNewPassword).text('Bitte Passwort eingeben.').addClass('is-visible');
            $(el.newPassword).addClass('is-error');
            valid = false;
        } else if (newPass.includes(' ')) {
            $(el.errNewPassword).text('Leerzeichen sind nicht erlaubt.').addClass('is-visible');
            $(el.newPassword).addClass('is-error');
            valid = false;
        } else if (!regex.test(newPass)) {
            $(el.errNewPassword).text('Passwort erfüllt nicht die Anforderungen.').addClass('is-visible');
            $(el.newPassword).addClass('is-error');
            valid = false;
        }

        if (!confirmPass) {
            $(el.errConfirmPassword).text('Bitte Passwort bestätigen.').addClass('is-visible');
            $(el.confirmPassword).addClass('is-error');
            valid = false;
        } else if (newPass !== confirmPass) {
            $(el.errConfirmPassword).text('Passwörter stimmen nicht überein.').addClass('is-visible');
            $(el.confirmPassword).addClass('is-error');
            valid = false;
        }
        return valid;
    };

    // Bindings
    const bindEmail = () => {
        $(el.formResetPassword).on('submit', (e) => {
            e.preventDefault();
            if (!validateEmail()) return;

            const $btn = $(el.formResetPassword).find('[type="submit"]');
            setButtonLoading($btn);

            $.ajax({
                // eslint-disable-next-line no-undef
                url: themeObj.ajaxUrl,
                type: 'POST',
                data: {
                    // eslint-disable-next-line no-undef
                    ...themeObj.ajax.mi_reset_send_otp,
                    email: $(el.email).val(),
                },
            })
                .done((res) => {
                    resetButtonLoading($btn);
                    if (!res.success) {
                        $(el.errEmail).text(res.data.message).addClass('is-visible');
                        return;
                    }

                    _reset_token = res.data.reset_token;

                    // remove this if want enalbled a OTP featured
                    // if (res.data.skip_otp) {
                    //     showStep(el.stepChangePassword);
                    //     return;
                    // }

                    $(el.otpEmail).text(res.data.email);
                    showStep(el.stepOtp);
                    // eslint-disable-next-line no-undef
                    startResendTimer(el.btnResend, el.resendTimer, themeObj.otp_resend_timer);
                    $(el.otpDigits).first().focus();
                })
                .fail(() => {
                    resetButtonLoading($btn);
                    $(el.errEmail).text('Ein Fehler ist aufgetreten.').addClass('is-visible');
                });
        });
    };

    const bindOtp = () => {
        $(el.formOtp).on('submit', (e) => {
            e.preventDefault();
            if (!validateOtp()) return;

            const otp = $(el.otpDigits).map(function () { return $(this).val(); }).get().join('');
            const $btn = $(el.formOtp).find('[type="submit"]');
            setButtonLoading($btn);

            $.ajax({
                // eslint-disable-next-line no-undef
                url: themeObj.ajaxUrl,
                type: 'POST',
                data: {
                    // eslint-disable-next-line no-undef
                    ...themeObj.ajax.mi_reset_verify_otp,
                    otp: otp,
                    reset_token: _reset_token,
                },
            })
                .done((res) => {
                    resetButtonLoading($btn);
                    if (!res.success) {
                        $(el.errOtp).text(res.data.message).addClass('is-visible');

                        // If max_attempts → force a return to the email step
                        if (res.data.max_attempts) {
                            _reset_token = null;
                            $(el.otpDigits).val('');
                            showStep(el.stepEmail);
                        }

                        return;
                    }

                    showStep(el.stepChangePassword);
                })
                .fail(() => {
                    resetButtonLoading($btn);
                    $(el.errOtp).text('Ein Fehler ist aufgetreten.').addClass('is-visible');
                });
        });
    };

    const bindChangePassword = () => {
        $(el.formChangePassword).on('submit', (e) => {
            e.preventDefault();
            if (!validateChangePassword()) return;

            const $btn = $(el.formChangePassword).find('[type="submit"]');
            setButtonLoading($btn);

            $.ajax({
                // eslint-disable-next-line no-undef
                url: themeObj.ajaxUrl,
                type: 'POST',
                data: {
                    // eslint-disable-next-line no-undef
                    ...themeObj.ajax.mi_reset_change_password,
                    // user_id: _user_id,
                    reset_token: _reset_token,
                    new_password: $(el.newPassword).val(),
                },
            })
                .done((res) => {
                    resetButtonLoading($btn);
                    if (!res.success) {
                        $(el.errNewPassword).text(res.data.message).addClass('is-visible');
                        return;
                    }

                    showStep(el.stepSuccess);
                })
                .fail(() => {
                    resetButtonLoading($btn);
                    $(el.errNewPassword).text('Ein Fehler ist aufgetreten.').addClass('is-visible');
                });
        });
    };

    const bindBack = () => {
        $(el.btnBackReset).on('click', () => {
            showStep(el.stepEmail);
        });
        $(el.btnBackChange).on('click', () => {
            // showStep(el.stepOtp);
            // showStep(el.stepEmail);
            // _user_id = null;
            _reset_token = null;
            $(el.otpDigits).val('');
            showStep(el.stepEmail);
        });
    };

    const bindResend = () => {
        $(el.btnResend).on('click', () => {
            // if (!_user_id) return;
            if (!_reset_token) return;

            $.ajax({
                // eslint-disable-next-line no-undef
                url: themeObj.ajaxUrl,
                type: 'POST',
                data: {
                    // eslint-disable-next-line no-undef
                    ...themeObj.ajax.mi_reset_resend_otp,
                    // user_id: _user_id,
                    reset_token: _reset_token,
                },
            })
                .done((res) => {
                    if (!res.success) return;
                    // eslint-disable-next-line no-undef
                    startResendTimer(el.btnResend, el.resendTimer, themeObj.otp_resend_timer);
                })
                .fail(() => {
                    console.error('Resend OTP failed');
                });
        });
    };

    init();
};

try {
    resetPassword();
} catch (error) {
    console.error('reset-password', error);
}